import { connect } from "@formily/react";
import { Card, CardContent } from "..";
import { getConfigValue } from "@rumble-it/common-lib/src/config";
import { Button } from "antd";
import clsx from "clsx";
import RumbleQrCode from "./RumbleQrCode";

interface RumbleImageCaptureHtmlProps {
  content?: string;
  cardClassname?: string;
  imageCaptureLink?: string;
  cdnUrl?: string;
  showQrCode?: boolean;
  imageCaptureLinkText?: string;
  footerContent?: string;
}

export const RumbleImageCaptureHtml = connect(
  (props: RumbleImageCaptureHtmlProps) => {
    const {
      content,
      cardClassname,
      cdnUrl = getConfigValue("cdnUrl"),
      imageCaptureLink = null,
      showQrCode = false,
      imageCaptureLinkText,
      footerContent,
    } = props;

    // Added for PostCSS parsing issue
    const _kimman_gradient =
      "bg-[linear-gradient(to_bottom,_rgba(159,182,176,0.2)_0%,_rgba(255,255,255,1)_15%)]";

    const _arval_gradient =
      "bg-[linear-gradient(to_bottom,_rgba(0,145,90,0.2)_0%,_rgba(255,255,255,1)_15%)]";

    const _schadenet_gradient =
      "bg-[linear-gradient(to_bottom,_rgba(255,214,0,0.2)_0%,_rgba(255,255,255,1)_15%)]";

    return (
      <>
        <div>
          <Card
            className={clsx(
              "max-w-4xl w-full bg-[linear-gradient(to_bottom,_rgba(59,130,246,0.2)_0%,_rgba(255,255,255,1)_15%)] text-gray-800 mt-16",
              cardClassname,
            )}
          >
            <CardContent className="py-7 flex flex-col">
              <div className="flex items-center justify-center">
                <div className="w-80 h-auto -my-72">
                  <img
                    src={`${cdnUrl}/static/dealer-intake/image-capture.svg`}
                    alt="Illustratie van een auto waarvan de schade wordt vastgelegd"
                  />
                </div>
              </div>

              {content ? (
                <div
                  className="mt-24"
                  dangerouslySetInnerHTML={{ __html: content }}
                />
              ) : null}

              {imageCaptureLink ? (
                <span className="flex flex-wrap gap-4 items-center justify-center">
                  <Button
                    type="primary"
                    href={imageCaptureLink}
                    target="_blank"
                  >
                    {imageCaptureLinkText ?? "Afbeeldingen uploaden"}
                  </Button>

                  {showQrCode === true && imageCaptureLink ? (
                    <span
                      style={{
                        flexDirection: "column",
                        alignContent: "center",
                        alignItems: "center",
                      }}
                      className="hidden sm:flex"
                    >
                      <RumbleQrCode
                        url={imageCaptureLink}
                        className="mb-4 float-right ml-4"
                      />
                      <span className="text-xs text-gray-500 text-center">
                        Scan de QR-code om de foto's te uploaden vanaf je
                        smartphone
                      </span>
                    </span>
                  ) : null}
                </span>
              ) : null}
              {footerContent ? (
                <div
                  className="mt-8"
                  dangerouslySetInnerHTML={{ __html: footerContent }}
                />
              ) : null}
            </CardContent>
          </Card>
        </div>
      </>
    );
  },
);

export default RumbleImageCaptureHtml;
